import React from 'react';
import ReactJson from 'react-json-view';
import { ListItem } from '@bb-ui/react-library/dist/components/ListItem';
import { ListItemIcon, createStyles, makeStyles } from '@bb-ui/react-library';
import { Attention } from '@bb-ui/icons/dist/medium/Attention';
import { ListItemText } from '@bb-ui/react-library/dist/components/ListItemText';
import { JobCardList } from './basic/JobCardList';
import { ExecutionDetailResponseBody } from '@lct-jobs/core';

const useStyles = makeStyles(() =>
  createStyles({
    listItem: {
      paddingTop: 6,
      paddingBottom: 6,
    },
    errorCode: {
      fontSize: '14px',
      fontWeight: 600,
    },
    errorMessage: {
      fontSize: '13px',
      color: 'rgba(0, 0, 0, 0.65)',
      marginTop: 2,
      lineHeight: 1.4,
      wordBreak: 'break-word' as const,
    },
    detailItem: {
      paddingTop: 4,
      paddingBottom: 4,
    },
    jsonContainer: {
      padding: '4px 16px 8px',
      background: 'rgba(0, 0, 0, 0.02)',
      borderRadius: 4,
    },
  }),
);

export interface JobErrorProps {
  jobExecution?: ExecutionDetailResponseBody;
}

function recursiveParse(object: any): any {
  if (typeof object === 'string') {
    try {
      return recursiveParse(JSON.parse(object));
    } catch {
      // It's not a JSON string
      return object;
    }
  }
  if (Array.isArray(object)) {
    return object.map((item) => recursiveParse(item));
  }
  if (typeof object === 'object') {
    return Object.fromEntries(Object.keys(object).map((key) => [key, recursiveParse(object[key])]));
  }
  return object;
}

export const JobErrorBox: React.FC<JobErrorProps> = (props) => {
  const classes = useStyles();
  const execution = props.jobExecution;

  return (
    <div>
      <JobCardList title="Job Error">
        <ListItem className={classes.listItem}>
          <ListItemIcon>
            <Attention />
          </ListItemIcon>
          <ListItemText
            primary={<span className={classes.errorCode}>{execution?.exception?.code}</span>}
            secondary={
              <span className={classes.errorMessage}>{execution?.exception?.message}</span>
            }
          />
        </ListItem>
        {execution?.exception?.detail && (
          <ListItem className={classes.detailItem}>
            <div className={classes.jsonContainer}>
              <ReactJson
                src={recursiveParse(execution?.exception?.detail)}
                name={false}
                collapsed={1}
              />
            </div>
          </ListItem>
        )}
      </JobCardList>
    </div>
  );
};
